import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { ThemeModule } from './@theme/theme.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import {
  NB_TIME_PICKER_CONFIG,
  NbDatepickerModule,
  NbDialogModule,
  NbLayoutModule,
  NbMenuModule,
  NbSidebarModule,
  NbWindowModule
} from '@nebular/theme';
import { NbDateFnsDateModule } from '@nebular/date-fns';
import { AuthGuard } from './auth/guards/auth.guard';
import { PagesGuard } from './auth/guards/pages.guard';
import { CanActivateForEntityGuard } from './auth/guards/can-activate-for-entity.guard';
import { EnforcementGuard } from './auth/guards/enforcement.guard';
import { LockedComponent } from './locked/locked.component';
import { CompleteProfileComponent } from './complete-profile/complete-profile.component';
import { ProfileCompletionGuard } from './auth/guards/profile-completion.guard';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [AppComponent, LockedComponent, CompleteProfileComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormsModule,
    NbLayoutModule, // /complete-profile wraps itself in nb-layout so toasts work
    AppRoutingModule,
    NbSidebarModule.forRoot(),
    NbMenuModule.forRoot(),
    NbDatepickerModule.forRoot(),
    NbDialogModule.forRoot(),
    NbWindowModule.forRoot(),
    NbDateFnsDateModule.forRoot({ format: 'dd/MM/yyyy' }),
    CoreModule.forRoot(),
    ThemeModule.forRoot()
  ],
  providers: [
    AuthGuard,
    PagesGuard,
    CanActivateForEntityGuard,
    EnforcementGuard,
    ProfileCompletionGuard,
    { provide: NB_TIME_PICKER_CONFIG, useValue: {} }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
